export default function dateToUnix(date) {
  return +(date.getTime() / 1000).toFixed(0);
}
